import React, { useEffect, useState } from 'react';
import { Col, Form, Input, Modal, Row, Select, Button, List, Text, message } from 'antd';
import { parentProductCategory } from 'utils/constants';
const { confirm } = Modal;

const ProductCategoryModal = ({ data, visibility, offVisible, form, onSubmit, selectedProductCategory, resetProductCategory, onDelete }) => {
  useEffect(() => {
    if (selectedProductCategory) {
      form.setFieldsValue({
        name: selectedProductCategory.name,
        parent: selectedProductCategory.parent || 'none'
      });
    } else {
      form.resetFields();
    }
  }, [selectedProductCategory]);

  const handleOk = async e => {
    form.validateFields((err, values) => {
      console.log(values);
      if (!err) {
        onSubmit(values, !selectedProductCategory ? 'new' : selectedProductCategory._id);
        form.resetFields();
        offVisible();
        resetProductCategory();
      }
    });
  };

  const handleCancel = e => {
    offVisible();
    resetProductCategory();
  };

  const handleConfirmDelete = () => {
    confirm({
      title: 'Are you sure you want to delete this product category?',
      content: 'This action cannot be undone.',
      onOk() {
        handleDelete();
        resetProductCategory();
      },
      onCancel() {
        console.log('Cancel');
      }
    });
  };

  const handleDelete = () => {
    offVisible();
    onDelete(selectedProductCategory._id);
  };

  const { getFieldDecorator } = form;

  return (
    <>
      <Modal
        title={!selectedProductCategory ? 'New Product Category' : selectedProductCategory.name}
        visible={visibility}
        onCancel={handleCancel}
        footer={
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <div>
              <Button key="submit" type="primary" onClick={handleOk}>
                {!selectedProductCategory ? 'Create' : 'Update'}
              </Button>
            </div>
            {selectedProductCategory && (
              <Button key="delete" type="danger" onClick={handleConfirmDelete}>
                Delete
              </Button>
            )}
          </div>
        }
      >
        <Form autoComplete="off">
          <Row gutter={16}>
            <Col span={24}>
              <Form.Item label="Category Name">
                {getFieldDecorator('name', {
                  rules: [{ required: true, message: 'Please input the category name' }]
                })(<Input placeholder="Category Name" />)}
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item label="Parent Category">
                {getFieldDecorator('parent')(
                  <Select placeholder="Select Parent Category">
                    {parentProductCategory.map(category => (
                      <Select.Option key={category.value} value={category.value}>
                        {category.label}
                      </Select.Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
    </>
  );
};

export default Form.create()(ProductCategoryModal);
